"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateTableHistoryItem = exports.TableBasedHistoryItem = void 0;
var tslib_1 = require("tslib");
var list_1 = require("@devexpress/utils/lib/utils/list");
var history_item_1 = require("../../base/history-item");
var TableBasedHistoryItem = (function (_super) {
    tslib_1.__extends(TableBasedHistoryItem, _super);
    function TableBasedHistoryItem(modelManipulator, boundSubDocument, tableIndex) {
        var _this = _super.call(this, modelManipulator) || this;
        _this.boundSubDocument = boundSubDocument;
        _this.tableIndex = tableIndex;
        return _this;
    }
    TableBasedHistoryItem.prototype.getTable = function () {
        return this.boundSubDocument.tables[this.tableIndex];
    };
    TableBasedHistoryItem.getRowCellsRanges = function (tableRow) {
        return list_1.ListUtils.map(tableRow.cells, function (cell) { return cell.interval; });
    };
    TableBasedHistoryItem.getTableCellsRanges = function (table) {
        return list_1.ListUtils.map(table.rows, function (row) { return TableBasedHistoryItem.getRowCellsRanges(row); });
    };
    return TableBasedHistoryItem;
}(history_item_1.HistoryItem));
exports.TableBasedHistoryItem = TableBasedHistoryItem;
var CreateTableHistoryItem = (function (_super) {
    tslib_1.__extends(CreateTableHistoryItem, _super);
    function CreateTableHistoryItem(modelManipulator, subDocument, firstParagraphIndex, rowCount, cellCount) {
        var _this = _super.call(this, modelManipulator, subDocument, -1) || this;
        _this.firstParagraphIndex = firstParagraphIndex;
        _this.rowCount = rowCount;
        _this.cellCount = cellCount;
        return _this;
    }
    CreateTableHistoryItem.prototype.redo = function () {
        this.tableIndex = this.modelManipulator.table.createTable(this.boundSubDocument, this.firstParagraphIndex, this.rowCount, this.cellCount).index;
    };
    CreateTableHistoryItem.prototype.undo = function () {
        this.modelManipulator.table.removeTable(this.boundSubDocument, this.getTable());
    };
    return CreateTableHistoryItem;
}(TableBasedHistoryItem));
exports.CreateTableHistoryItem = CreateTableHistoryItem;
